const root = typeof window === 'undefined' ? global : window;

root.abExperiments = root.abExperiments || {};

export const abExperiments = root.abExperiments;
